export default {
  haulers: 'Haulers',
  setup: 'Setup',
  driverExperience: 'Driver Experience',
  users: 'Users',
};
